import { BehaviorTemplateElement } from '@eab-eip/hi-behavior-template/hi-behavior-template';
import { AsHIC, HIP, BehaviorElement } from '@eab-eip/hi-component/hi-component';
import { PolymerElement, html } from 'polymer';

import f1 from '@eab-pip/pi-f1';

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @customElement
 * @polymer
 * @appliesMixin BehaviorElement
 * @appliesMixin BehaviorTemplateElement
 */
export class PlaceholderElement extends BehaviorTemplateElement(BehaviorElement(AsHIC(PolymerElement))) {
  static get is() {
    return 'hi-placeholder';
  }

  static get template() {
    return html`
      <style is="custom-style" include="hi-theme"></style>
      <style>
        :host {
          position: relative;
          min-height: calc(var(--hi-px-48) * 2em);
        }

        :host([busy]) {
          display: block;
          -moz-user-focus: ignore !important;
          pointer-events: none !important;
          user-select: none !important;
          cursor: default !important;
        }

        .ph-item {
          position: relative;
          display: flex;
          flex-wrap: wrap;
          padding: calc(var(--hi-fx-14) * 2) var(--hi-fx-14) var(--hi-fx-14) var(--hi-fx-14);
          overflow: hidden;
          background-color: var(--hi-clr--white);
        }

        .ph-item,
        .ph-item *,
        .ph-item ::after,
        .ph-item ::before {
          box-sizing: border-box;
        }

        .ph-item::before {
          content: ' ';
          z-index: 1;
          position: absolute;
          top: var(--hi-fx-0);
          right: var(--hi-fx-0);
          bottom: var(--hi-fx-0);
          left: 50%;
          width: 500%;
          margin-left: -250%;
          -webkit-animation: phAnimation 0.8s linear infinite;
          animation: phAnimation 0.8s linear infinite;
          background: linear-gradient(
              to right,
              rgba(255, 255, 255, 0) 46%,
              rgba(255, 255, 255, 0.35) 50%,
              rgba(255, 255, 255, 0) 54%
            )
            50% 50%;
        }

        .ph-item > * {
          flex: 1 1 auto;
          display: flex;
          flex-flow: column;
          padding-right: var(--hi-fx-14);
          padding-left: var(--hi-fx-14);
        }

        .ph-row {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: var(--hi-fx-8);
        }

        .ph-row div {
          height: var(--hi-fx-8);
          margin-bottom: var(--hi-fx-8);
          background-color: var(--hi-clr--gray-4);
        }

        .ph-row .big,
        .ph-row.big div {
          height: calc(var(--hi-fx-10) * 2);
          margin-bottom: var(--hi-fx-14);
        }

        .ph-row .empty {
          background-color: var(--hi-clr--transparent);
        }

        .ph-col-1 {
          flex: 0 0 var(--hi-grid--size-1);
        }

        .ph-col-2 {
          flex: 0 0 var(--hi-grid--size-2);
        }

        .ph-col-3 {
          flex: 0 0 var(--hi-grid--size-3);
        }

        .ph-col-4 {
          flex: 0 0 var(--hi-grid--size-4);
        }

        .ph-col-5 {
          flex: 0 0 var(--hi-grid--size-5);
        }

        .ph-col-6 {
          flex: 0 0 var(--hi-grid--size-6);
        }

        .ph-col-7 {
          flex: 0 0 var(--hi-grid--size-7);
        }

        .ph-col-8 {
          flex: 0 0 var(--hi-grid--size-8);
        }

        .ph-col-9 {
          flex: 0 0 var(--hi-grid--size-9);
        }

        .ph-col-10 {
          flex: 0 0 var(--hi-grid--size-10);
        }

        .ph-col-11 {
          flex: 0 0 var(--hi-grid--size-11);
        }

        .ph-col-12 {
          flex: 0 0 var(--hi-grid--size-12);
        }

        .ph-avatar {
          position: relative;
          width: calc(var(--hi-site--full-width) / 3);
          background-color: var(--hi-clr--gray-4);
          margin-bottom: var(--hi-fx-14);
          border-radius: 50%;
          overflow: hidden;
        }

        .ph-avatar::before {
          content: ' ';
          display: block;
          padding-top: var(--hi-site--full-width);
        }

        .ph-picture {
          width: var(--hi-site--full-width);
          height: calc(var(--hi-fx-10) * 12);
          background-color: var(--hi-clr--gray-4);
          margin-bottom: var(--hi-fx-14);
        }

        @-webkit-keyframes phAnimation {
          0% {
            transform: translate3d(-30%, 0, 0);
          }
          100% {
            transform: translate3d(30%, 0, 0);
          }
        }

        @keyframes phAnimation {
          0% {
            transform: translate3d(-30%, 0, 0);
          }
          100% {
            transform: translate3d(30%, 0, 0);
          }
        }
      </style>

      <div hidden$="[[ !busy ]]">
        <div class="ph-item">
          <div class="ph-col-12">
            <div class="ph-row">
              <dom-repeat items="[[ __rows ]]">
                <template>
                  <div class$="ph-col-[[ item.length ]]"></div>
                  <div class$="ph-col-[[ item.empty ]] empty"></div>
                </template>
              </dom-repeat>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  /**
   *
   */
  rows: unknown[];
  private __rows: { length: number; empty: number }[];

  /**
   *
   */
  busy: boolean;

  static get properties() {
    return {
      busy: {
        type: Boolean,
        value: true,
        observer: '__onBusyChanged',
        reflectToAttribute: true,
        notify: true
      },
      rows: {
        type: Array,
        observer: '__rowsChanged'
      }
    };
  }

  static get observedAttributes() {
    return ['busy', 'rows'];
  }

  constructor() {
    super();

    this.rows = [];
    this.__rows = [
      {
        length: 5,
        empty: 7
      },
      {
        length: 6,
        empty: 6
      },
      {
        length: 7,
        empty: 5
      }
    ];
  }

  static get autoBinding() {
    return {
      signal: 'busy-changed',
      field: 'busy'
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('role', 'status');
  }

  __onBusyChanged(busyState: boolean) {
    this.setAttribute('aria-busy', `${busyState}`);
    if (!busyState) {
      this.render();
    }
  }

  __rowsChanged(rows: unknown) {
    if (rows.length > 0) {
      this.__rows = f1.map((val: number) => {
        return {
          length: val,
          empty: 12 - val
        };
      }, rows);
    }
  }

  render() {
    this._renderTemplate();
    let template = this.querySelector('template');

    if (!this.__children) {
      if (!template) {
        const observer = new MutationObserver(() => {
          template = this.querySelector('template');

          if (template) {
            observer.disconnect();
            this.render();
          } else {
            throw new Error('hi-placeholder requires a <template> or it has no usefulness');
          }
        });

        observer.observe(this, {
          childList: true
        });
      }
    }
  }

  /**
   * @returns {string} the busy label if the spinner is on
   */
  toString() {
    return this.busy ? 'loading' : '';
  }
}

HIP.factory.element(PlaceholderElement);
export default PlaceholderElement.is;
